import CardImageGallery from "./CardImageGallery";
import { getImageUrl } from "../../utils/imageHelper";

const SignificantProjects = ({ projects: dynamicProjects }) => {
  const staticProjects = [
    {
      title: "Business Manangement Application",
      description: "An android and web app for storing information about daily transaction with sync function to sync information between android app and web",
      image: "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg"    
    },
    {
      title: "I-care",
      description: "Informative application about food/nutrition/ingredients/exercise.",
      image: "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg"    
    },
    {
      title: "Car Chaser",
      description: "An android and web app for storing information about daily transaction with sync function to sync information between android app and web databases using API.",
      image:
        "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg",
    },
    {
      title: "Department Store mangement system",
      description: "A Sales Application for Department Store with many features like management, sales of products, orders, receipts, inventory",
      image:
        "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg",
    }
  ];

  const projects =
    dynamicProjects && dynamicProjects.length > 0
      ? dynamicProjects.map((p) => ({
          ...p,
          image: getImageUrl(p.image),
        }))
      : staticProjects;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
        {projects.map((project, index) => (
          <div
            key={index}
            className="group bg-white rounded-[2rem] border border-slate-200/60 overflow-hidden shadow-sm hover:shadow-2xl hover:shadow-blue-200/40 transition-all duration-500 h-full hover:-translate-y-2"
          >
            <CardImageGallery imageSrc={project.image} altTitle={project.title} className="h-56 md:h-64" />
            <div className="p-6 md:p-8">
              <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 tracking-tight group-hover:text-blue-600 transition-colors capitalize">
                {project.title}
              </h3>
              <p className="text-slate-500 text-[13px] md:text-sm font-medium leading-relaxed">
                {project.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default SignificantProjects;
